<template>
    <button
        class="flex items-center space-x-2 text-left w-full rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600"
        :title="spec.title"
        v-on="$listeners"
    >
        <div class="flex-shrink-0" v-if="spec.estimate_specific">
            <estimates-old-specs-icon :spec="spec"></estimates-old-specs-icon>
        </div>
        <div class="truncate flex-1 flex flex-col">
            <div class="truncate w-full">{{ spec.title }}</div>
            <div class="truncate w-full text-xs text-gray-500">
                <span v-if="! spec.estimate_specific && ! spec.approved" class="text-yellow-600">Unapproved</span>
                <span v-if="! spec.estimate_specific && ! spec.approved"> • </span>
                <span>{{ spec.cost_per_uom | toCurrency }} per {{ spec.unit_of_measure }}</span>
            </div>
        </div>
        <div
            v-if="badge !== undefined"
            class="flex-shrink-0 rounded bg-gray-200 px-1.5 py-0.5 text-xs font-semibold font-mono"
            v-text="badge"
        ></div>
    </button>
</template>

<script>
export default {
    props: {
        spec: Object,
        badge: Number,
    },
}
</script>
